// ProductsList.jsx — écran liste : barre d'app, recherche, filtres, cartes produit.
import React, { useMemo, useState } from "react";
import {
  Ico, useIcons, fmt, productStatus, thumbStyle, initials,
} from "./productsShared";
import MobileModuleHeader, { MobileHeaderAction } from "../MobileModuleHeader";

function ProductCard({ p, onOpen }) {
  const st = productStatus(p);
  return (
    <button className="pcard" onClick={() => onOpen(p.id)}>
      <div className="thumb" style={thumbStyle(p.cat)}>
        {p.image ? <img src={p.image} alt="" /> : initials(p.name)}
      </div>
      <div className="pcard__main">
        <div className="pcard__name">{p.name}</div>
        <div className="pcard__meta">
          <span className="pcard__code">{p.code}</span>
          <span>{p.cat}</span>
        </div>
        <div className="pcard__bottom">
          <span className={"pill " + st.cls}><span className="dot" />{st.label}</span>
          <span style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)" }}>
            {fmt(p.stock)} {p.unit}
          </span>
        </div>
      </div>
      <div className="pcard__side">
        <div className="price">{fmt(p.sale)}<small> F</small></div>
        <Ico name="chevron-right" style={{ width: 18, height: 18, color: "var(--muted-2)" }} />
      </div>
    </button>
  );
}

export default function ProductsList({
  products, contextLabel = "Magasin Central",
  onOpenProduct, onAdd, onMenu, onScan, loading = false, canCreate = true,
}) {
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");
  useIcons();

  const counts = useMemo(() => {
    const c = { all: products.length, ok: 0, low: 0, out: 0 };
    products.forEach((p) => { c[productStatus(p).k] += 1; });
    return c;
  }, [products]);

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return products.filter((p) => {
      if (filter !== "all" && productStatus(p).k !== filter) return false;
      if (q && !(
        String(p.name || "").toLowerCase().includes(q) ||
        String(p.code || "").toLowerCase().includes(q) ||
        String(p.cat || "").toLowerCase().includes(q)
      )) return false;
      return true;
    });
  }, [products, query, filter]);

  const chip = (k, label, cls) => (
    <button
      className={"chip " + (cls || "") + (filter === k ? " on" : "")}
      onClick={() => setFilter(k)}
    >
      {label}<span className="chip__n">{counts[k]}</span>
    </button>
  );

  return (
    <div className="screen screen--in">
      <MobileModuleHeader
        title="Produits"
        subtitle={`${products.length} références`}
        onMenu={onMenu}
        actions={
          <MobileHeaderAction label="Scanner un produit" onClick={onScan} icon="scan-line" />
        }
        context={<span className="appbar__ctx"><Ico name="store" />{contextLabel}</span>}
      >
        <div className={"search" + (query ? " has-val" : "")}>
          <Ico name="search" />
          <input
            type="text" inputMode="search"
            placeholder="Rechercher nom, code, catégorie…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button className="search__clear" onClick={() => setQuery("")}>
            <Ico name="x" style={{ width: 18, height: 18 }} />
          </button>
        </div>
        <div className="chips">
          {chip("all", "Tous")}
          {chip("ok", "En stock")}
          {chip("low", "Stock bas", "warn")}
          {chip("out", "Rupture", "danger")}
        </div>
      </MobileModuleHeader>

      <div className="body">
        {loading ? (
          <div className="empty">
            <Ico name="loader-circle" className="spin" />
            <b>Chargement des produits</b>
            <span>Synchronisation du catalogue en cours.</span>
          </div>
        ) : visible.length ? (
          <div className="list">
            {visible.map((p) => (
              <ProductCard key={p.id} p={p} onOpen={onOpenProduct} />
            ))}
          </div>
        ) : (
          <div className="empty">
            <Ico name="package-search" />
            <b>Aucun produit</b>
            <span>Aucun résultat pour ce filtre{query ? ` · « ${query} »` : ""}.</span>
          </div>
        )}
      </div>

      {canCreate ? (
        <button className="fab" onClick={onAdd}><Ico name="plus" />Nouveau</button>
      ) : null}
    </div>
  );
}
